<div class="grid p-fluid my-5">
    <div class="col-12">
        <div class="card">
            <p-toolbar>
                <div class="p-toolbar-group-left">
                    <h1 class="m-0">View Daily Summary Files</h1>
                </div>
                <div class="p-toolbar-group-right date-selector-toolbar">
                    <input
                        type="date"
                        [(ngModel)]="selectedDateString"
                        class="date-input mr-2"
                        placeholder="Select Date">
                    <p-button
                        label="Load"
                        icon="pi pi-refresh"
                        (onClick)="onLoadButtonClick()"
                        [loading]="isListLoading">
                    </p-button>
                </div>
            </p-toolbar>
            <p-table [value]="dailySummaryFiles" responsiveLayout="scroll" [paginator]="true" [rows]="10"
             [totalRecords]="dailySummaryFiles.length || 0" [loading]="isListLoading">
                <ng-template pTemplate="header">
                    <tr>
                        <th>File Name</th>
                        <th>Imported At</th>
                        <th>Type</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dailySummaryFile>
                    <tr>
                        <td class="mpi-text-truncate">{{ dailySummaryFile.fileName }}</td>
                        <td class="mpi-text-truncate">{{ dailySummaryFile.createdAt | date:'short' }}</td>
                        <td class="mpi-text-truncate">{{ dailySummaryFile.importType }}</td>
                        <td>
                            <p-button label="Download" [link]="true" (onClick)="downloadFile(dailySummaryFile.fileContent, dailySummaryFile.fileName)" />
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="3" class="text-center">
                            <b *ngIf="hasError" class="error-message">{{ errorMessage }}</b>
                            <b *ngIf="!hasError">No Data Found.</b>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
